import React from 'react';
import Topnav from './Topnav';
import SocialIcons from './SocialIcons';

function Header(props){

    let header = null;
    let headerContent = null;
    let headerStyles = {};
    let headerStyle = null;
    let toplinks = [];
    let toggleBtn = null;
    let containerStyle = {};

    toggleBtn = {
        display : "none"
    };

    let isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) || ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
        isMobile = true;
    }

    if(typeof props.styles.headerStyle === "undefined"){
        headerStyles.backgroundColor = '#FFF';
        headerStyles.color = '#343a40';
        headerStyles.linkColor = '#343a40';
    }else{
        headerStyles.backgroundColor = props.styles.headerStyle.backgroundColor;
        headerStyles.color = props.styles.headerStyle.color;
        headerStyles.linkColor = props.styles.headerStyle.color;
    }

    if(props.template === "TABBED_THEATER" || props.template === "TABBED_THEATER_FOOTER"){
        containerStyle.maxWidth = "960px";
    }

    if(typeof props.toplinks !== "undefined"){
         if(props.template === "GET_STARTED" || 
            props.template === "GET_STARTED_FOOTER" ){
            toplinks = props.toplinks;
            toggleBtn = {
                display : "block"
            }; 
         }else if(props.template === "LINKED_UP" || 
         props.template === "LINKED_UP_FOOTER" || 
         props.template === "LINKED_UP_LEFT_FOOTER" || 
         props.template === "LINKED_UP_LEFT" ||
         props.template === "LP_LINKS_WITH_ICONS"){
            toplinks= []; 
            toggleBtn = {
                display : "none"
            };          
         }else{
            toplinks = props.toplinks;
            toggleBtn = {
                display : "none"
            };
         }
     }

    if(props.template === "CROSSBAR" || props.template === "CROSSBAR_FOOTER"){
        headerStyle = {
            backgroundColor :"#FFF",
            color : "#333"      
        };

        if(typeof props.styles.bodyStyle !== "undefined"){
            let pageBody = document.querySelector("body");
            pageBody.style.backgroundColor = props.styles.bodyStyle.backgroundColor;
            pageBody.style.color = props.styles.bodyStyle.color;
        }else{
            let pageBody = document.querySelector("body");
            pageBody.style.backgroundColor = "#FFF";
            pageBody.style.color = "#333";
        }
        
        headerStyles.linkColor = "rgb(66, 139, 202)";

    }else if( props.template === "CROSSBAR_LEFT" || props.template === "CROSSBAR_LEFT_FOOTER"){

        headerStyle = {
            backgroundColor :"#FFF",
            color : "#333",   
            borderTop : props.styles["header-bar"].borderTop   
        };       
        headerStyles.linkColor = "rgb(66, 139, 202)";

    } else if (props.template === "SOCIALIZE" || props.template === "SOCIALIZE_FOOTER") {
        //code by anand
        headerStyle = {
            background: "transparent linear-gradient(to right, #FFF 0%, #FFF 53%, #E0E0E0 81%, #FFFCFC 99%) repeat scroll 0% 0%",
        };
        //-end
    }else{  
        headerStyle = {
            backgroundColor : headerStyles.backgroundColor,
            color : headerStyles.color       
        };
    }

    const brandStyle = {
        color : headerStyles.color
    };

    const linkStyle = {
        color : headerStyles.linkColor
    };

    let icon = null;

    if(props.dealername !== "" || toplinks.length > 0 || props.dealernamemissing !== ""){

        if(props.template === "GET_STARTED" || props.template === "GET_STARTED_FOOTER"){
            headerContent = props.dealername;
            if(props.preview && !props.dealername){
                headerContent = <span className="dealer-name-missing">{props.dealernamemissing}</span>;
            }
        }

        

        if( toplinks.length > 0){
            icon = <i className="fa fa-bars"></i>;
        }
        

        header = <nav className="navbar navbar-expand-lg" 
            style={headerStyle}>
                <div className="container" style={containerStyle}>
                    <a style={brandStyle} className="navbar-brand" href="#0">
                        {headerContent}                                   
                    </a>
                    <button style={toggleBtn} className="navbar-toggler" 
                        type="button" 
                        data-toggle="collapse" 
                        data-target="#navbarsExampleDefault" 
                        aria-controls="navbarsExampleDefault" 
                        aria-expanded="false" 
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" style={{
            backgroundColor : headerStyle.backgroundColor,
            color : headerStyle.color       
        }}>{icon}</span>
                    </button>
                    <Topnav linkStyle={linkStyle} links={toplinks} dealerName={props.dealerName} template={props.template} shareurl={props.shareurl} />
                </div>
            </nav>
    }else{
        header = null;
   }

   if(props.template === "LINKED_UP" || props.template === "LINKED_UP_LEFT" || props.template === "LINKED_UP_FOOTER" || props.template === "LINKED_UP_LEFT_FOOTER" || props.template === "LP_LINKS_WITH_ICONS"){
            toplinks = props.toplinks;
            if(props.dealer.dealer_phone){
                headerContent = isMobile ? <a style={{textDecoration:"none",color:"inherit"}} href={"tel:" + props.dealer.dealer_phone}>
                    <span><i className="fa fa-phone"></i> {props.dealer.dealer_phone}</span></a> : <span>
                    <i className="fa fa-phone"></i> {props.dealer.dealer_phone}
                </span>
            }else{
                headerContent = null;
            }

            if(props.preview && props.dealer.dealer_phone_missing){
                headerContent = <span><i className="fa fa-phone"></i> <span className="dealer-phone-missing">{props.dealer.dealer_phone_missing}</span></span>
            }            
            
            
            icon = <i className="fa fa-bars"></i>;


            header = <nav className="navbar navbar-expand-lg" 
            style={headerStyle}>
                <div className="container">
                    <a style={brandStyle} className="navbar-brand" href="#0">
                        {headerContent}                                   
                    </a>
                    <button style={toggleBtn} className="navbar-toggler" 
                        type="button" 
                        data-toggle="collapse" 
                        data-target="#navbarsExampleDefault" 
                        aria-controls="navbarsExampleDefault" 
                        aria-expanded="false" 
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" style={{
            backgroundColor : headerStyle.backgroundColor,
            color : headerStyle.color       
        }}>{icon}</span>
                    </button>
                    <Topnav linkStyle={linkStyle} links={toplinks} dealerName={props.dealerName} template={props.template} shareurl={props.shareurl} />
                </div>
            </nav>
    }

    if(props.template === "CROSSBAR_FOOTER" || props.template === "CROSSBAR_LEFT_FOOTER"){
        header = <nav className="navbar navbar-expand-lg" 
        style={headerStyle}>
            <div className="container">
            <SocialIcons shareurl={props.shareurl} dealerName={props.dealerName} template={props.template} />            
                <button style={toggleBtn} className="navbar-toggler" 
                    type="button" 
                    data-toggle="collapse" 
                    data-target="#navbarsExampleDefault" 
                    aria-controls="navbarsExampleDefault" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" style={{
        backgroundColor : headerStyle.backgroundColor,
        color : headerStyle.color       
    }}>{icon}</span>
                </button>
                
                <Topnav linkStyle={linkStyle} links={toplinks} template={props.template} dealerName={props.dealerName} shareurl={props.shareurl} />
            </div>
        </nav>
    }


    return header;

}
export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js